import type { UserType, User } from 'types';
import { isVerified } from './is-verified';

export const isAllowed = (user: User, roles: UserType[], verified = true) => {
    return roles.includes(user.type) && (verified ? isVerified(user) : true);
};
